export const getLanguage = state => {
  return state.LanguageReducer && state.LanguageReducer.language;
};

export const getQrErrorMessage = state => {
  return state.QrReducer.error;
}

export const selectSessionStatus = state => {
  return state.SessionReducer.sessionDetails.sessionStatus;
}

export const selectSessionType = state => {
  return state.SessionReducer.sessionDetails.sessionType;
}

export const selectQrActiveScreen = state => {
  return state.QrReducer.activeQRScreen;
}

export const selectQRLicenseKey = state => {
  return state.QrReducer.qrLicenseKey;
}

export const selectIsDisabledMenu = state => {
  return state.QrReducer.isDisabledMenu;
}
